import { z } from 'zod';
import { eligibleTourWireSchema } from './feature-tour';

export const guidedExperienceStatusSchema = z.enum([
  'NOT_STARTED',
  'IN_PROGRESS',
  'COMPLETED',
  'DISMISSED',
  'SKIPPED',
]);

export const eligibleExperienceWireSchema = z.object({
  experience_id: z.string(),
  experience_version: z.number().int(),
  status: guidedExperienceStatusSchema.nullable(),
  current_step: z.number().int().nullable(),
  dismissible: z.boolean(),
});

export const eligibleExperiencesResponseWireSchema = z.object({
  experiences: z.array(eligibleExperienceWireSchema),
  tours: z.array(eligibleTourWireSchema).optional().default([]),
});

export const guidedExperienceStateWireSchema = z.object({
  id: z.string(),
  user_id: z.string(),
  experience_id: z.string(),
  experience_version: z.number().int(),
  status: guidedExperienceStatusSchema,
  current_step: z.number().int().nullable(),
  payload: z.string().nullable(),
  started_at: z.string().nullable(),
  completed_at: z.string().nullable(),
  dismissed_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type GuidedExperienceStatus = z.infer<typeof guidedExperienceStatusSchema>;
export type EligibleExperienceWire = z.infer<typeof eligibleExperienceWireSchema>;
export type EligibleExperiencesResponseWire = z.infer<typeof eligibleExperiencesResponseWireSchema>;
export type GuidedExperienceStateWire = z.infer<typeof guidedExperienceStateWireSchema>;
